export const orderTimeUnitObjArr = [
  {
    label: "Month",
    value: "month",
  },
  {
    label: "Year",
    value: "year",
  },
  {
    label: "Week",
    value: "week",
  },
  {
    label: "Day",
    value: "day",
  },
  {
    label: "Never Ordered",
    value: "never_ordered",
  },
  {
    label: "Least Ordered",
    value: "least_ordered",
  },
  {
    label: "Most Frequently Ordered",
    value: "frequently_ordered",
  },
];

export const dateIntervalObjArr = [
  {
    label: "Today",
    value: "today",
  },
  {
    label: "Upcoming",
    value: "upcoming",
  },
  {
    label: "Past",
    value: "past",
  },
];

export const orderTimeObjArr = [
  {
    label: "1",
    value: "1",
  },
  {
    label: "2",
    value: "2",
  },
  {
    label: "3",
    value: "3",
  },
  {
    label: "4",
    value: "4",
  },
  {
    label: "5",
    value: "5",
  },
  {
    label: "6",
    value: "6",
  },
  {
    label: "7",
    value: "7",
  },
  {
    label: "8",
    value: "8",
  },
  {
    label: "9",
    value: "9",
  },
  {
    label: "10",
    value: "10",
  },
  {
    label: "11",
    value: "11",
  },
  {
    label: "12",
    value: "12",
  },
];

export const ratingObjArr = [
  {
    label: "1",
    value: "1",
  },
  {
    label: "2",
    value: "2",
  },
  {
    label: "3",
    value: "3",
  },
  {
    label: "4",
    value: "4",
  },
  {
    label: "5",
    value: "5",
  },
];

export const retentionTypeObjArr = [
  {
    label: "Retained",
    value: "retained",
  },
  {
    label: "Prospect",
    value: "prospect",
  },
  {
    label: "Changed Place",
    value: "changed-place",
  },
  {
    label: "Not Coming",
    value: "not-coming",
  },
  {
    label: "Invalid Number",
    value: "invalid-number",
  },
  {
    label: "Restricted",
    value: "restricted",
  },
];

export const searchTypeObjArr = [
  {
    label: "Starts With",
    value: "starts",
  },
  {
    label: "Ends With",
    value: "ends",
  },
  {
    label: "Contains",
    value: "contains",
  },
];

export const activityTypeObjArr = [
  {
    label: "Customer Created Date",
    value: "customer_created_on",
  },
  {
    label: "Next Follow Up Date",
    value: "pending_follow_up",
  },
];

export const customerTypeObjArr = [
  {
    label: "Standard",
    value: "standard",
  },
  {
    label: "Valued",
    value: "valued",
  },
  {
    label: "Premium",
    value: "premium",
  },
  {
    label: "Super Premium",
    value: "super-premium",
  },
];

export const statusObjArr = [
  {
    label: "Active",
    value: "1",
  },
  {
    label: "InActive",
    value: "0",
  },
];

export const songTypeObjArr = [
  {
    label: "Vocal",
    value: "vocal",
  },
  {
    label: "Instrumental",
    value: "instrumental",
  },
];

export const mediaTypeObjArr = [
  {
    label: "Audio",
    value: "audio",
  },
  {
    label: "Video",
    value: "video",
  },
  {
    label: "Other",
    value: "other",
  },
];

export const mediaSourceObjArr = [
  {
    label: "Form",
    value: "form",
  },
  {
    label: "Client",
    value: "client",
  },
  {
    label: "Csv",
    value: "csv",
  },
];

export const mediaCatObjArr = [
  {
    label: "Music",
    value: "music",
  },
  {
    label: "Commercial",
    value: "commercial",
  },
];

export const singerCombObjArr = [
  {
    label: "Solo",
    value: "solo",
  },
  {
    label: "Duet",
    value: "duet",
  },
  {
    label: "Group",
    value: "group",
  },
];

export const chartForObjArr = [
  {
    label: "Master",
    value: "master",
  },
  {
    label: "Company",
    value: "company",
  },
  {
    label: "Public",
    value: "public",
  },
];

export const chartTypeObjArr = [
  {
    label: "Popular",
    value: "popular",
  },
  {
    label: "Custom",
    value: "custom",
  },
  {
    label: "Event",
    value: "event",
  },
];

export const chartAvailabilityObjArr = [
  {
    label: "Always",
    value: "always",
  },
  {
    label: "On Date",
    value: "on-date",
  },
];

export const musicScheduleAvailabilityObjArr = [
  {
    label: "Always - Default Playlist",
    value: "1",
  },
  {
    label: "On Date",
    value: "0",
  },
];

export const chartCatTypeObj = {
  client_event: "client-event",
  client: "client",
  master: "master",
  public: "public",
};

export const scheduleForTime = {
  current: {
    value: "current",
    label: "Current",
  },
  upcoming: {
    value: "upcoming",
    label: "Upcoming",
  },
  past: {
    value: "past",
    label: "Past",
  },
  all: {
    value: "all",
    label: "All",
  },
};

export const storeScheduleItems = {
  music: {
    value: "music",
    label: "Music",
  },
  commercial: {
    value: "commercial",
    label: "Commercial",
  },
  event_play_list: {
    value: "event_play_list",
    label: "Event Play List",
  },
  player_stop_time: {
    value: "player_stop_time",
    label: "Player Stop Time",
  },
};

export const mediaNatureObjArr = [
  {
    label: "Song",
    value: "song",
  },
  {
    label: "Ad",
    value: "ad",
  },
  {
    label: "Jingle",
    value: "jingle",
  },
  {
    label: "Podcast",
    value: "podcast",
  },
  {
    label: "Toh",
    value: "toh",
  },
  {
    label: "Sweep",
    value: "sweep",
  },
];

export const commercialNatureObjArr = [
  {
    label: "Ad",
    value: "ad",
  },
  {
    label: "Jingle",
    value: "jingle",
  },
  {
    label: "Podcast",
    value: "podcast",
  },
  {
    label: "Toh",
    value: "toh",
  },
  {
    label: "Sweep",
    value: "sweep",
  },
];

export const commercialUseForObjArr = [
  {
    label: "Internal",
    value: "internal",
  },
  {
    label: "External",
    value: "external",
  },
];

export const deviceTypeObjArr = [
  {
    label: "Web",
    value: "web",
  },
  {
    label: "Android",
    value: "android",
  },
  {
    label: "ios",
    value: "ios",
  },
  {
    label: "Windows Desktop",
    value: "windows_desktop",
  },
  {
    label: "Linux Desktop",
    value: "linux_desktop",
  },
];

export const genderObjArr = [
  {
    label: "Gender",
    value: "",
  },
  {
    label: "Male",
    value: "m",
  },
  {
    label: "Female",
    value: "f",
  },
  {
    label: "Trans Gender",
    value: "t",
  },
];

export const followupForObj = {
  order_booking: {
    label: "Order Booking",
    value: "order-booking",
  },
  feedback: {
    label: "Feedback",
    value: "feedback",
  },
  general: {
    label: "General",
    value: "general",
  },
};

export const followupForObjArr = [
  {
    label: "Order Booking",
    value: "order-booking",
  },
  {
    label: "Feedback",
    value: "feedback",
  },
  {
    label: "General",
    value: "general",
  },
];

export const followupStatusObj = {
  all: {
    label: "All",
    value: "",
  },
  pending: {
    label: "Pending",
    value: "pending",
  },
  inprogress: {
    label: "In Progress",
    value: "inprogress",
  },
  completed: {
    label: "Completed",
    value: "completed",
  },
  incomplete: {
    label: "Not Completed",
    value: "incomplete",
  },
};

export const followupStatusObjArr = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Pending",
    value: "pending",
  },
  {
    label: "In Progress",
    value: "inprogress",
  },
  {
    label: "Completed",
    value: "completed",
  },
  {
    label: "Not Completed",
    value: "incomplete",
  },
];

export const orderStatusObjArr = [
  {
    label: "Pending",
    value: "pending",
  },
  {
    label: "In Progress",
    value: "inprogress",
  },
  {
    label: "Served",
    value: "served",
  },
  {
    label: "Cancelled",
    value: "cancelled",
  },
];

export const midNightToMorningTimeObjArr = [
  {
    label: "12:00 AM",
    value: "00:00",
  },
  {
    label: "12:30 AM",
    value: "00:30",
  },
  {
    label: "01:00 AM",
    value: "01:00",
  },
  {
    label: "01:30 AM",
    value: "01:30",
  },
  {
    label: "02:00 AM",
    value: "02:00",
  },
  {
    label: "02:30 AM",
    value: "02:30",
  },
  {
    label: "03:00 AM",
    value: "03:00",
  },
  {
    label: "03:30 AM",
    value: "03:30",
  },
  {
    label: "04:00 AM",
    value: "04:00",
  },
  {
    label: "04:30 AM",
    value: "04:30",
  },
  {
    label: "05:00 AM",
    value: "05:00",
  },
  {
    label: "05:30 AM",
    value: "05:30",
  },
];

export const midNightToMorningHourObjArr = [
  {
    label: "12:00 AM",
    value: "00:00",
  },
  {
    label: "01:00 AM",
    value: "01:00",
  },
  {
    label: "02:00 AM",
    value: "02:00",
  },
  {
    label: "03:00 AM",
    value: "03:00",
  },
  {
    label: "04:00 AM",
    value: "04:00",
  },
  {
    label: "05:00 AM",
    value: "05:00",
  },
];

export const dayTimeObjArr = [
  {
    label: "06:00 AM",
    value: "06:00",
  },
  {
    label: "06:30 AM",
    value: "06:30",
  },
  {
    label: "07:00 AM",
    value: "07:00",
  },
  {
    label: "07:30 AM",
    value: "07:30",
  },
  {
    label: "08:00 AM",
    value: "08:00",
  },
  {
    label: "08:30 AM",
    value: "08:30",
  },
  {
    label: "09:00 AM",
    value: "09:00",
  },
  {
    label: "09:30 AM",
    value: "09:30",
  },
  {
    label: "10:00 AM",
    value: "10:00",
  },
  {
    label: "10:30 AM",
    value: "10:30",
  },
  {
    label: "11:00 AM",
    value: "11:00",
  },
  {
    label: "11:30 AM",
    value: "11:30",
  },
  {
    label: "12:00 PM",
    value: "12:00",
  },
  {
    label: "12:30 PM",
    value: "12:30",
  },
  {
    label: "01:00 PM",
    value: "13:00",
  },
  {
    label: "01:30 PM",
    value: "13:30",
  },
  {
    label: "02:00 PM",
    value: "14:00",
  },
  {
    label: "02:30 PM",
    value: "14:30",
  },
  {
    label: "03:00 PM",
    value: "15:00",
  },
  {
    label: "03:30 PM",
    value: "15:30",
  },
  {
    label: "04:00 PM",
    value: "16:00",
  },
  {
    label: "04:30 PM",
    value: "16:30",
  },
  {
    label: "05:00 PM",
    value: "17:00",
  },
  {
    label: "05:30 PM",
    value: "17:30",
  },
  {
    label: "06:00 PM",
    value: "18:00",
  },
  {
    label: "06:30 PM",
    value: "18:30",
  },
  {
    label: "07:00 PM",
    value: "19:00",
  },
  {
    label: "07:30 PM",
    value: "19:30",
  },
  {
    label: "08:00 PM",
    value: "20:00",
  },
  {
    label: "08:30 PM",
    value: "20:30",
  },
  {
    label: "09:00 PM",
    value: "21:00",
  },
  {
    label: "09:30 PM",
    value: "21:30",
  },
  {
    label: "10:00 PM",
    value: "22:00",
  },
  {
    label: "10:30 PM",
    value: "22:30",
  },
];

export const minSecObjArr = [
  {
    label: "00",
    value: "00",
  },
  {
    label: "01",
    value: "01",
  },
  {
    label: "02",
    value: "02",
  },
  {
    label: "03",
    value: "03",
  },
  {
    label: "04",
    value: "04",
  },
  {
    label: "05",
    value: "05",
  },
  {
    label: "06",
    value: "06",
  },
  {
    label: "07",
    value: "07",
  },
  {
    label: "08",
    value: "08",
  },
  {
    label: "09",
    value: "09",
  },
  {
    label: "10",
    value: "10",
  },
  {
    label: "11",
    value: "11",
  },
  {
    label: "12",
    value: "12",
  },
  {
    label: "13",
    value: "13",
  },
  {
    label: "14",
    value: "14",
  },
  {
    label: "15",
    value: "15",
  },
  {
    label: "16",
    value: "16",
  },
  {
    label: "17",
    value: "17",
  },
  {
    label: "18",
    value: "18",
  },
  {
    label: "19",
    value: "19",
  },
  {
    label: "20",
    value: "20",
  },
  {
    label: "21",
    value: "21",
  },
  {
    label: "22",
    value: "22",
  },
  {
    label: "23",
    value: "23",
  },
  {
    label: "24",
    value: "24",
  },
  {
    label: "25",
    value: "25",
  },
  {
    label: "26",
    value: "26",
  },
  {
    label: "27",
    value: "27",
  },
  {
    label: "28",
    value: "28",
  },
  {
    label: "29",
    value: "29",
  },
  {
    label: "30",
    value: "30",
  },
  {
    label: "31",
    value: "31",
  },
  {
    label: "32",
    value: "32",
  },
  {
    label: "33",
    value: "33",
  },
  {
    label: "34",
    value: "34",
  },
  {
    label: "35",
    value: "35",
  },
  {
    label: "36",
    value: "36",
  },
  {
    label: "37",
    value: "37",
  },
  {
    label: "38",
    value: "38",
  },
  {
    label: "39",
    value: "39",
  },
  {
    label: "40",
    value: "40",
  },
  {
    label: "41",
    value: "41",
  },
  {
    label: "42",
    value: "42",
  },
  {
    label: "43",
    value: "43",
  },
  {
    label: "44",
    value: "44",
  },
  {
    label: "45",
    value: "45",
  },
  {
    label: "46",
    value: "46",
  },
  {
    label: "47",
    value: "47",
  },
  {
    label: "48",
    value: "48",
  },
  {
    label: "49",
    value: "49",
  },
  {
    label: "50",
    value: "50",
  },
  {
    label: "51",
    value: "51",
  },
  {
    label: "52",
    value: "52",
  },
  {
    label: "53",
    value: "53",
  },
  {
    label: "54",
    value: "54",
  },
  {
    label: "55",
    value: "55",
  },
  {
    label: "56",
    value: "56",
  },
  {
    label: "57",
    value: "57",
  },
  {
    label: "58",
    value: "58",
  },
  {
    label: "59",
    value: "59",
  },
];

export const dayHourObjArr = [
  {
    label: "06:00 AM",
    value: "06:00",
  },
  {
    label: "07:00 AM",
    value: "07:00",
  },
  {
    label: "08:00 AM",
    value: "08:00",
  },
  {
    label: "09:00 AM",
    value: "09:00",
  },
  {
    label: "10:00 AM",
    value: "10:00",
  },
  {
    label: "11:00 AM",
    value: "11:00",
  },
  {
    label: "12:00 PM",
    value: "12:00",
  },
  {
    label: "01:00 PM",
    value: "13:00",
  },
  {
    label: "02:00 PM",
    value: "14:00",
  },
  {
    label: "03:00 PM",
    value: "15:00",
  },
  {
    label: "04:00 PM",
    value: "16:00",
  },
  {
    label: "05:00 PM",
    value: "17:00",
  },
  {
    label: "06:00 PM",
    value: "18:00",
  },
  {
    label: "07:00 PM",
    value: "19:00",
  },
  {
    label: "08:00 PM",
    value: "20:00",
  },
  {
    label: "09:00 PM",
    value: "21:00",
  },
  {
    label: "10:00 PM",
    value: "22:00",
  },
];

export const eveningToMidNightHourObjArr = [
  {
    label: "11:00 PM",
    value: "23:00",
  },
];

export const eveningToMidNightTimeObjArr = [
  {
    label: "11:00 PM",
    value: "23:00",
  },
  {
    label: "11:30 PM",
    value: "23:30",
  },
  {
    label: "11:59 PM",
    value: "23:59",
  },
];

export const fullDayTimeObjArr = [
  ...midNightToMorningTimeObjArr,
  ...dayTimeObjArr,
  ...eveningToMidNightTimeObjArr,
];

export const fullDayHourObjArr = [
  ...midNightToMorningHourObjArr,
  ...dayHourObjArr,
  ...eveningToMidNightHourObjArr,
];

export const orderServeAtObjArr = [
  {
    value: "store",
    label: "Store",
  },
  {
    value: "home",
    label: "Home",
  },
];

export const orderServeAtObj = {
  store: {
    value: "store",
    label: "Store",
  },
  home: {
    value: "home",
    label: "Home",
  },
};

export const operatorsObjArr = [
  {
    value: "gte",
    label: ">=",
  },
  {
    value: "lte",
    label: "<=",
  },
  {
    value: "eq",
    label: "=",
  },
  {
    value: "gt",
    label: ">",
  },
  {
    value: "lt",
    label: "<",
  },
];

export const foodTypeObjArr = [
  {
    value: "hot",
    label: "Hot",
  },
  {
    value: "cold",
    label: "Cold",
  },
  {
    value: "normal",
    label: "Normal",
  },
];

export const buildingTypeObjArr = [
  {
    value: "residential",
    label: "Residential",
  },
  {
    value: "commercial",
    label: "Commercial",
  },
];

export const sizeObjArr = [
  {
    id: "1",
    value: "small",
    label: "Small",
  },
  {
    id: "2",
    value: "medium",
    label: "Medium",
  },
  {
    id: "3",
    value: "large",
    label: "Large",
  },
  {
    id: "4",
    value: "extra_large",
    label: "Extra Large",
  },
];

export const availableOnDayObjArr = [
  {
    label: "All Days",
    value: "8",
  },
  {
    label: "Monday",
    value: "1",
  },
  {
    label: "Tuesday",
    value: "2",
  },
  {
    label: "Wednesday",
    value: "3",
  },
  {
    label: "Thursday",
    value: "4",
  },
  {
    label: "Friday",
    value: "5",
  },
  {
    label: "Saturday",
    value: "6",
  },
  {
    label: "Sunday",
    value: "7",
  },
];

export const weekDaysObjArr = [
  {
    label: "Sunday",
    value: "sun",
  },
  {
    label: "Monday",
    value: "mon",
  },
  {
    label: "Tuesday",
    value: "tue",
  },
  {
    label: "Wednesday",
    value: "wed",
  },
  {
    label: "Thursday",
    value: "thu",
  },
  {
    label: "Friday",
    value: "fri",
  },
  {
    label: "Saturday",
    value: "sat",
  },
];

export const weekAllDaysObjArr = [
  {
    label: "All Day",
    value: "all",
  },
  ...weekDaysObjArr,
];

export const monthArr = [
  {
    label: "January",
    value: "01",
  },
  {
    label: "February",
    value: "02",
  },
  {
    label: "March",
    value: "03",
  },
  {
    label: "April",
    value: "04",
  },
  {
    label: "May",
    value: "05",
  },
  {
    label: "June",
    value: "06",
  },
  {
    label: "July",
    value: "07",
  },
  {
    label: "August",
    value: "08",
  },
  {
    label: "September",
    value: "09",
  },
  {
    label: "October",
    value: "10",
  },
  {
    label: "November",
    value: "11",
  },
  {
    label: "December",
    value: "12",
  },
];

export const eventArr = [
  {
    label: "Birthday",
    value: "birthday",
  },
  {
    label: "Anniversary",
    value: "anniversary",
  },
];

export const dayRangeArr = [
  {
    label: "Week1 (1st to 7th)",
    value: "01",
  },
  {
    label: "Week2 (8th to 15th)",
    value: "02",
  },
  {
    label: "Week3 (16th to 23rd)",
    value: "03",
  },
  {
    label: "Week4 (24th to 31st)",
    value: "04",
  },
];

export const monthDaysArr = [
  {
    label: "01",
    value: "01",
  },
  {
    label: "02",
    value: "02",
  },
  {
    label: "03",
    value: "03",
  },
  {
    label: "04",
    value: "04",
  },
  {
    label: "05",
    value: "05",
  },
  {
    label: "06",
    value: "06",
  },
  {
    label: "07",
    value: "07",
  },
  {
    label: "08",
    value: "08",
  },
  {
    label: "09",
    value: "09",
  },
  {
    label: "10",
    value: "10",
  },
  {
    label: "11",
    value: "11",
  },
  {
    label: "12",
    value: "12",
  },
  {
    label: "13",
    value: "13",
  },
  {
    label: "14",
    value: "14",
  },
  {
    label: "15",
    value: "15",
  },
  {
    label: "16",
    value: "16",
  },
  {
    label: "17",
    value: "17",
  },
  {
    label: "18",
    value: "18",
  },
  {
    label: "19",
    value: "19",
  },
  {
    label: "20",
    value: "20",
  },
  {
    label: "21",
    value: "21",
  },
  {
    label: "22",
    value: "22",
  },
  {
    label: "23",
    value: "23",
  },
  {
    label: "24",
    value: "24",
  },
  {
    label: "25",
    value: "25",
  },
  {
    label: "26",
    value: "26",
  },
  {
    label: "27",
    value: "27",
  },
  {
    label: "28",
    value: "28",
  },
  {
    label: "29",
    value: "29",
  },
  {
    label: "30",
    value: "30",
  },
  {
    label: "31",
    value: "31",
  },
];

export const userTypeObjArr = [
  { id: 1, value: "b", label: "Site Admin" },
  { id: 2, value: "c", label: "Client" },
];

export const serviceRatingObjArr = [
  { value: "1", label: "Very Bad" },
  { value: "2", label: "Bad" },
  { value: "3", label: "Average" },
  { value: "4", label: "Good" },
  { value: "5", label: "Very Good" },
  { value: "6", label: "Excellent" },
];

export const serviceRatingArr = {
  1: { value: "1", label: "Very Bad" },
  2: { value: "2", label: "Bad" },
  3: { value: "3", label: "Average" },
  4: { value: "4", label: "Good" },
  5: { value: "5", label: "Very Good" },
  6: { value: "6", label: "Excellent" },
};

export const daysOffsetArr = {
  today: { offsetFrom: 0, offsetTo: 0 },
  tomorrow: { offsetFrom: 1, offsetTo: 1 },
  next_2_days: { offsetFrom: 0, offsetTo: 2 },
  next_7_days: { offsetFrom: 0, offsetTo: 7 },
  next_30_days: { offsetFrom: 0, offsetTo: 30 },
  yesterday: { offsetFrom: -1, offsetTo: -1 },
  last_2_days: { offsetFrom: -2, offsetTo: 0 },
  last_7_days: { offsetFrom: -7, offsetTo: 0 },
  last_30_days: { offsetFrom: -30, offsetTo: 0 },
  custom: { offsetFrom: 0, offsetTo: 0 },
};

export const orderDayTypeObj = {
  today: {
    value: "today",
    label: "Today",
    daysOptions: [
      {
        label: "Today",
        value: "today",
      },
    ],
  },
  upcoming: {
    value: "upcoming",
    label: "Upcoming",
    daysOptions: [
      {
        label: "Tomorrow",
        value: "tomorrow",
      },
      {
        label: "Next 2 Days",
        value: "next_2_days",
      },
      {
        label: "Next 7 Days",
        value: "next_7_days",
      },
      {
        label: "Next 30 Days",
        value: "next_30_days",
      },
      {
        label: "Custom",
        value: "custom",
      },
    ],
  },
  past: {
    value: "past",
    label: "Past",
    daysOptions: [
      {
        label: "Yesterday",
        value: "yesterday",
      },
      {
        label: "Last 2 Days",
        value: "last_2_days",
      },
      {
        label: "Last 7 Days",
        value: "last_7_days",
      },
      {
        label: "Last 30 Days",
        value: "last_30_days",
      },
      {
        label: "Custom",
        value: "custom",
      },
    ],
  },
  all: {
    value: "all",
    label: "All",
    daysOptions: [
      {
        label: "Today",
        value: "today",
      },
      {
        label: "Yesterday",
        value: "yesterday",
      },
      {
        label: "Last 2 Days",
        value: "last_2_days",
      },
      {
        label: "Last 7 Days",
        value: "last_7_days",
      },
      {
        label: "Last 30 Days",
        value: "last_30_days",
      },
      {
        label: "Tomorrow",
        value: "tomorrow",
      },
      {
        label: "Next 2 Days",
        value: "next_2_days",
      },
      {
        label: "Next 7 Days",
        value: "next_7_days",
      },
      {
        label: "Next 30 Days",
        value: "next_30_days",
      },
      {
        label: "Custom",
        value: "custom",
      },
    ],
  },
};

export const roleObjArr = {
  super_admin: {
    id: 1,
    name: "super-admin",
    label: "Site Admin",
    role_type: "b",
    weight: "100",
  },
  admin: {
    id: 2,
    name: "admin",
    label: "Admin",
    role_type: "b",
    weight: "99",
  },
  client_admin: {
    id: 3,
    name: "client-admin",
    label: "Client Admin",
    role_type: "c",
    weight: "90",
  },
  store_admin: {
    id: 4,
    name: "store-admin",
    label: "Store Admin",
    role_type: "c",
    weight: "80",
  },
  store_staff: {
    id: 5,
    name: "store-staff",
    label: "Store Staff",
    role_type: "c",
    weight: "50",
  },
  campaign_manager: {
    id: 7,
    name: "campaign-manager",
    label: "Campaign Manager",
    role_type: "c",
    weight: "70",
  },
  customer: {
    id: 6,
    name: "customer",
    label: "Customer",
    role_type: "f",
    weight: "10",
  },
};

export const roleTypeArr = { backend: "b", client: "c", frontend: "f" };
export const clientRoleArr = [3, 4, 5, 7];

export const statusArr = { active: "1", inactive: "0", deleted: "2" };

export const custSourceArr = {
  campaign: "5",
  pamphlet: "4",
  friends_reference: "3",
  whatsapp_group: "2",
  existing_customer: "1",
};

export const genderArr = {
  all: "",
  male: "m",
  female: "f",
  trans_gender: "t",
};

export const orderStatusObj = {
  pending: { label: "Pending", value: "pending" },
  inprogress: { label: "In Progress", value: "inprogress" },
  served: { label: "Served", value: "served" },
  cancelled: { label: "Cancelled", value: "cancelled" },
};

export const dateFormatObj = {
  calendar_d_m_y: "dd-MM-yyyy",
  db_format: "yyyy-MM-dd",
  calendar_d_m_y_h_m: "dd-MM-yyyy HH:mm",
  moment_y_m_d: "YYYY-MM-DD",
  moment_y_m_d_h_m: "yyyy-MM-DD HH:mm",
  display_d_m_y: "DD-MM-yyyy",
  display_day_d_m_y: "ddd DD-MM-yyyy",
  display_d_m_y_h_m: "DD-MM-yyyy hh:mm a",
  display_h_m: "hh:mm a",
  display_day_d_m_y_h_m: "ddd DD-MM-yyyy hh:mm a",
  display_date_month: "DD MMMM",
};

export const onOffArr = { on: "1", off: "0" };

export const yesNoObj = { yes: "Yes", no: "No" };

export const yesNoObjArr = [
  {
    label: "Yes",
    value: "1",
  },
  {
    label: "No",
    value: "0",
  },
];

export const groupForObjArr = [
  {
    label: "Music",
    value: "music",
  },
  {
    label: "Non-Music",
    value: "non-music",
  },
];

export const playOnExactTimeObjArr = [
  {
    label: "Play On Exact Time",
    value: "1",
  },
  {
    label: "After Song Completion",
    value: "0",
  },
];

export const pagerLayoutArr = ["total", "-", "limit", "|", "pager", "skip"];

export const appConstObj = {
  record_per_page: 10,
  limit_options: [10, 30, 50, 100],
  mobile_length: 10,
};

export const orderConfObj = {
  tax_percent: 0,
};

export const maxUploadSizeInMB = 20;

export const httpStatusArr = {
  ok: 200,
  server_error: 500,
  bad_request: 400,
  not_found: 404,
  unauthorised_access: 401,
  forbidden_access: 403,
};

export const messageTypeArr = {
  info: "info",
  success: "success",
  warning: "warning",
  error: "error",
};

export const limitOfDataFromApi = {
  forUsers: 3,
  forGroup: 3,
  forRoles: 3,
};

export const dateFormat = {
  dateFormatForNotification: "DD-MM-YYYY",
};

export const IS_ALPHA_REGEX = /^[a-zA-Z]+$/;
export const IS_ALPHANUMERIC_REGEX = /^[a-zA-Z0-9]+$/;
export const IS_ALPHANUMERIC_WITH_SPACE_REGEX =
  /^(?:[a-zA-Z0-9][a-zA-Z0-9\s]*)?$/;
export const IS_ALPHANUMERIC_WITH_DASH_REGEX =
  /^(?:[a-zA-Z0-9][a-zA-Z0-9-_]*)?$/;
export const IS_ALPHANUMERIC_WITH_DASH_SPACE_REGEX =
  /^(?:[a-zA-Z0-9][a-zA-Z0-9-_\s]*)?$/;
